import 'css-chunk:src/applications/ShopifyApp/components/ShopifyShippingLines.scss';export default {
  "ShopifyShippingLines": "_ShopifyShippingLines_zva1q_1",
  "grayText": "_grayText_zva1q_10",
  "numberInput": "_numberInput_zva1q_13"
};